import { gql } from '@apollo/client';

export const GET_CA_OFFERS = gql`
  query GetSearchResults($input: GetPromotionOfferByMultiParamsInput) {
    getPromotionOfferByMultiParams(input: $input) {
      expiryDate
      msrp
      modelFamily
      modelName
      modelId
      bodyStyleEn
      image
      trimName
      mtlTrimName
      type
      featuredOffer
      featuredHierarchy
      legalCopyEn
      legalCopyFr
      legalCopyCn
      legalBannerCn
      configuratorUrlEn
      configuratorUrlFr
      dag
      year
      modelSalesCode
      cpoOffers {
        featuredOffer
        featuredHierarchy
        apr0_24
        apr25_36
        apr37_48
        apr49_60
        apr61_72
        rateReduction
      }
      offers {
        title
        offertypes {
          __typename
          ... on PromotionsLeaseMinimumPayment {
            name
            leaseDownPayment
            leaseMinimumPayment
            leasePaymentFrequency
          }
          ... on PromotionsLeaseRateReduction {
            name
            leaseRateReduction
            leaseExpiryDate
          }
          ... on PromotionsLeasePercentage {
            name
            leaseRate
            leasePeriod
            leaseApr
          }
          ... on PromotionsLeaseCash {
            name
            audiCredit
          }
          ... on PromotionsLeaseOffersPlus {
            name
            offerPlusEn
            offerPlusFr
            offerPlusCn
          }
          ... on PromotionsFinancePercentage {
            name
            financeRate
            financeApr
            financePeriod
          }
          ... on PromotionsFinanceRateReduction {
            name
            financeRateReduction
            financeExpiryDate
          }
          ... on PromotionsFinanceMinimumPayment {
            name
            financeDownPayment
            financeMinimumPayment
            financePaymentFrequency
          }
          ... on PromotionsFinanceCash {
            name
            audiCredit
          }
          ... on PromotionsFinanceOffersPlus {
            name
            offerPlusEn
            offerPlusFr
            offerPlusCn
          }
          ... on PromotionsCashOffer {
            name
            cashOffer
          }
          ... on PromotionsCashOfferPlus {
            name
            offerPlusEn
            offerPlusFr
            offerPlusCn
          }
        }
      }
    }
  }
`;
